import Splide from '@splidejs/splide';

class ResponsiveCarousel {
	constructor($element, options){
		if(!$element || !options){
			throw new Error('There isn\'t an element to apply your carousel to, or your options are empty.');
		}

		this.instance = new Splide($element, options);
		this.instance.mount();
	}

	destroy(){
		if(this.instance){
			this.instance.destroy(true);
		}
	}
}

export default ResponsiveCarousel;